export type BrokerNerdsBarkerCoreEnumsUserAuthType = (typeof BrokerNerdsBarkerCoreEnumsUserAuthType)[keyof typeof BrokerNerdsBarkerCoreEnumsUserAuthType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsUserAuthType = {
  Native: 'Native',
  Google: 'Google',
} as const;
